import controller from './sliders.controller';
import template from './sliders.view.html';

let SlidersComponent = {
  template,
  controller,
  bindings : {
    dbData : '<',
    dbName : '<'
  }
};

export default SlidersComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/home/sliders/sliders.component.js
 **/